import './Home.css';
import React, { useEffect } from 'react';

import Header from '../../components/Header/Header';
import LawyerSection from '../../components/Sections/LawyerSection';
import Footer from '../../components/Footer/Footer';
import ActivitiesBoard from '../../components/ActivitiesBoard/ActivitiesBoard';


function Home({ user, fetchUser }) {

  // Buscar ultimo usuário logado, cliente pediu para desabilitar
  // useEffect(() => fetchUser, [])

  return (
    <div className={`Home`}>
      <Header user={user} fetchUser={fetchUser} />
      <LawyerSection user={user} />
      <ActivitiesBoard user={user} />
      <Footer />
    </div>
  );
}

export default Home;
